import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "../../lib/i18n";

const STORAGE_KEY = "lep_cookies_v1";

export default function CookiesNotice() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved =
      typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
    if (!saved) {
      const timer = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(timer);
    }
  }, []);

  const close = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, choice);
    } catch (_) {}
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          data-testid="cookies-notice"
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 z-[70] max-w-md bg-white border border-black p-5 sm:p-6 shadow-[0_12px_32px_rgba(0,0,0,0.08)]"
        >
          <div className="flex items-center gap-3 mb-3">
            <span dir="auto" className="font-display font-black text-xs uppercase tracking-[0.25em]">
              {t("cookies.title")}
            </span>
            <span className="flex-1 h-px bg-black/15" />
          </div>
          <p dir="auto" className="font-body text-[12px] sm:text-[13px] leading-relaxed text-black/75">
            {t("cookies.body")}
          </p>
          <div className="mt-5 flex items-center gap-3">
            <button
              onClick={() => close("accept")}
              data-testid="cookies-accept-btn"
              dir="auto"
              className="inline-flex items-center gap-2 bg-black text-white px-6 py-3 text-[10px] uppercase tracking-[0.22em] font-bold border border-black hover:bg-white hover:text-black transition-colors"
            >
              {t("cookies.accept")}
            </button>
            <button
              onClick={() => close("decline")}
              data-testid="cookies-decline-btn"
              dir="auto"
              className="inline-flex items-center gap-2 bg-white text-black px-6 py-3 text-[10px] uppercase tracking-[0.22em] font-bold border border-black hover:bg-black hover:text-white transition-colors"
            >
              {t("cookies.decline")}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
